/**
* ============================================================
* GlowWell — Track Your Order JavaScript
* File: assets/track-order.js
* Version: 2.0
*
* Loaded with defer — runs after DOM is ready.
* Vanilla JS. Zero dependencies. No jQuery. No frameworks.
* Single IIFE to avoid polluting the global scope.
*
* Behaviour:
* 1. Validates that the tracking field is not empty.
* 2. Shows an inline error with ARIA announcement if empty.
* 3. Shows a loading state on the button while redirecting.
* 4. Redirects to the configured tracking URL.
* 5. Resets state if the user clears the field.
* ============================================================
*/
(function () {
'use strict';
/* ── Default tracker base URL ──────────────────────────── */
const DEFAULT_TRACKER = 'https://t.17track.net/en#nums=';
/* ── DOM references ────────────────────────────────────── */
const form = document.getElementById('track-order-form');
if (!form) return; // Section not on page — exit early.
const input = document.getElementById('track-order-input');
const btn = document.getElementById('track-order-btn');
const error = document.getElementById('track-order-error');
const errMsg = document.getElementById('track-order-error-msg');
const status = document.getElementById('track-order-status');
const field = input ? input.closest('.track-order__field') : null;
/* ── Resolve tracker URL from section setting ───────────── */
function getTrackerUrl() {
const configured = (form.dataset.trackerUrl || '').trim();
return configured || DEFAULT_TRACKER;
}
/* ── Show / hide error state ────────────────────────────── */
function showError(message) {
if (!error || !field) return;
if (errMsg && message) errMsg.textContent = message;
error.hidden = false;
field.classList.add('has-error');
input.setAttribute('aria-invalid', 'true');
}
function clearError() {
if (!error || !field) return;
error.hidden = true;
field.classList.remove('has-error');
input.removeAttribute('aria-invalid');
}
/* ── Show / hide loading state ──────────────────────────── */
function setLoading(isLoading) {
if (!btn) return;
btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
btn.disabled = isLoading;
// Announce to screen readers
if (status) {
status.textContent = isLoading ? 'Loading tracking information…' : '';
}
}
/* ── Main track handler ─────────────────────────────────── */
function handleTrack() {
const raw = input ? input.value.trim() : '';
const encoded = encodeURIComponent(raw);
clearError();
// Validate: field must not be empty
if (!raw) {
showError(errMsg ? errMsg.textContent : 'Please enter a tracking number.');
input.focus();
return;
}
// Show loading state
setLoading(true);
// Small delay so loading state is visible before navigation
window.setTimeout(function () {
const destination = getTrackerUrl() + '?nums=' + encoded;
window.open(destination, '_blank', 'noopener,noreferrer');
// Reset after opening — user stays on page
setLoading(false);
}, 600);
}
/* ── Button click ───────────────────────────────────────── */
if (btn) {
btn.addEventListener('click', handleTrack);
}
/* ── Enter key in input ─────────────────────────────────── */
if (input) {
input.addEventListener('keydown', function (event) {
if (event.key === 'Enter') {
event.preventDefault();
handleTrack();
}
});
/* Clear error on input */
input.addEventListener('input', function () {
if (this.value.trim()) {
clearError();
}
/* Trigger floating label via class (for browsers that may not
support :not(:placeholder-shown) reliably in all Shopify themes) */
this.classList.toggle('has-value', this.value.length > 0);
});
}
})();